<template>
  <div class="Positions">
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-card class="box-card" v-loading="positions_loading">
          <div class="flex-space-between flex-wrap label-md-bold-black stock-ranking capitalize">
            <div class="flex bottom-margin-10">
              <img src="../assets/images/rank0.png" style="height: 18px; margin-right: 10px" />
              Positions
              <span v-if="getPositions.length">({{ getPositions.length }})</span>
            </div>

            <div class="flex">
              <el-input v-model="search_position" size="mini" suffix-icon="el-icon-search" placeholder="Search" style="width: 210px"></el-input>

              <!-- <div class="download-btn left-margin-10">
                                <i class="el-icon-download"></i> Download
                            </div> -->
            </div>
          </div>

          <table class="holdings-description-table top-margin-15">
            <thead>
              <tr>
                <!-- <th><el-checkbox v-model="check_positions" @change="checkAllPositions()"></el-checkbox></th> -->
                <th style="text-align: left">Instrument</th>
                <th v-if="userProfile && userProfile.utm_source != 'Choice'">Product</th>
                <th>Qty</th>
                <th v-if="userProfile && (userProfile.utm_source == 'Zebu' || userProfile.utm_source == 'Rupeezy')" style="width: 150px">Buy quantity</th>
                <th v-if="userProfile && (userProfile.utm_source == 'Zebu' || userProfile.utm_source == 'Rupeezy')" style="width: 150px">Sell quantity</th>
                <th v-if="userProfile && userProfile.utm_source == 'Rupeezy'" style="width: 160px">Transaction</th>
                <th>Avg.</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, item_index) in getPositions.filter((data) => !search_position || data.title.toLowerCase().includes(search_position.toLowerCase()))" :key="item_index">
                <!-- <td><el-checkbox v-model="item.checked"></el-checkbox></td> -->

                <td style="text-align: left">{{ item.title }}</td>
                <td v-if="userProfile && userProfile.utm_source != 'Choice'">
                  <div class="tag">
                    {{ item.product_type == 'CNC' || item.product_type == 'C' ? 'Delivery' : item.product_type == 'MIS' || item.product_type == 'I' ? 'Intraday' : item.product_type == 'B' ? 'Bracket Order' : item.product_type == 'V' ? 'Cover Order' : item.product_type == 'M' ? 'Carry Forword' : item.product_type == 'NRML' ? 'Normal' : item.product_type }}
                  </div>
                </td>

                <td>{{ item.quantity }}</td>
                <td v-if="userProfile && (userProfile.utm_source == 'Zebu' || userProfile.utm_source == 'Rupeezy')">
                  <span style="color: #079e3e">
                    {{ item.buy_quantity }}
                  </span>
                </td>
                <td v-if="userProfile && (userProfile.utm_source == 'Zebu' || userProfile.utm_source == 'Rupeezy')">
                  <span style="color: #e72726">
                    {{ item.sell_quantity }}
                  </span>
                </td>

                <td v-if="userProfile && userProfile.utm_source == 'Rupeezy'">
                  {{ item.transaction_type }}
                </td>

                <td>{{ item.avg_net_price }}</td>
              </tr>
            </tbody>
          </table>

          <NoDataFound v-if="!getPositions.length" style="padding: 0"></NoDataFound>
        </el-card>
      </el-col>
    </el-row>

    <!-- <button @click="openPaytmSite()">Open Button</button> -->
  </div>
</template>

<script>
import { serverAddr } from '../networkConfig';
import NoDataFound from '@/components/NoDataFound.vue';

export default {
  name: 'Positions',

  components: {
    NoDataFound,
  },

  data() {
    return {
      search_position: '',
      check_positions: false,
      positions: [],
      positions_loading: false,
    };
  },

  mounted() {
    if (localStorage.getItem('selected_broker')) {
      this.getPositionsNetWorkCallBack();
      if (localStorage.getItem('selected_broker') == 10) {
        // this.generateTpinForPaytm()
      }
    }
  },

  methods: {
    generateTpinForPaytm(stock) {
      serverAddr
        .post('/trade/v1/generate_tpin_form', {
          broker_id: localStorage.getItem('selected_broker') ? Number(localStorage.getItem('selected_broker')) : '',
          trade_type: stock.exchange,
          isin_list: [
            {
              isin: 'INE413X01027',
              qty: stock.net_quantity,
            },
          ],
        })
        .then((response) => {
          if (response.data.status) {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openPaytmSite() {
      let apiUrl = 'https://eDIS.cdslindia.com/eDIS/VerifyDIS';
      var form = document.createElement('form');
      form.setAttribute('method', 'POST');
      form.setAttribute('action', apiUrl);
      // form.setAttribute("target", "_blank");

      let params = {
        DPId: '88800',
        ReqId: '20478646',
        Version: '1.2',
        TransDtls: 'zUi1cFSMvnMUG2qaHkvfSpWOAvBb+61ioARzb3igCQ+g8PTHD65VaTqwGgao6kPP+hqFAsXq9WYt/fG7GMpneRWjP8GjinC5ywNKcx+aNU9SR9BHrhySaIwEYqk5ExSHVvHozXvqDL8TsXA+g9gd6tNaKlS5/7DbmBbxlvkCeVU08RyWCXF7KZFOu8finlZkzrHLYeMpTi8dxUFpylK3qWkSnUM6cTWdAsecyv1HqjKR2dU1bnfT9pRLF1yv9MsJhNWKMkOyj3jQmZf2bJfJj/a8Cf140xRx4mUxYQ3qs4ZfkrKlzy4c6E1qZ83+dwOC1Ign6cH0lK6mSuGIR4bJkfqW3fY7fmsB+YhV+Zmb0Ec9zTcuBlt8YMnFbKYVrDcpBmmqw0sQl3lclW113wbzsSMlzwMwdH4XgH+snyNXC/pQljq/We0CF0EOPl8ugUFaGY00huvL4fsRnX4oPbzjHQ==',
      };

      for (var p in params) {
        let input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', p);
        input.setAttribute('value', params[p]);
        form.appendChild(input);
      }
      document.body.appendChild(form);
      form.submit();
    },
    checkAllPositions() {
      if (this.check_positions) {
        this.positions.forEach((e) => {
          e.checked = true;
        });
      } else {
        this.positions.forEach((e) => {
          e.checked = false;
        });
      }
    },

    getPositionsNetWorkCallBack() {
      this.positions_loading = true; //displayed loader

      serverAddr
        .post('/trade/v1/position', {
          broker_id: localStorage.getItem('selected_broker') ? Number(localStorage.getItem('selected_broker')) : '',
          page_segment: 'equity',
        })
        .then((response) => {
          if (response.data.status) {
            this.positions = response.data.data;
          } else {
            this.positions = [];
          }

          this.positions_loading = false; //hide loader
        })
        .catch((error) => {
          console.log(error);
          this.positions_loading = false; //hide loader
          this.positions = [];
        });
    },
  },

  computed: {
    getPositions() {
      return this.positions;
    },
    userProfile() {
      return JSON.parse(localStorage.getItem('profile'));
    },
  },
};
</script>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.Positions {
  .box-card {
    box-shadow: none;
    border-radius: 10px;
  }

  .tag {
    padding: 4px;
    border-radius: 4px;
    background: #2d2e8d;
    opacity: 1;
    color: #fff;
    width: 100px;
    margin: 0 auto;
    font-size: 10px;
  }

  table {
    th {
      width: 120px;
    }
  }
}
</style>
